export default "__VITE_ASSET__DyGwpfhe__"